import _ from 'underscore';

export function updateAdStrengthPropertyForFilter(entitySchema, i18n) {
  const adStrengthProperty = entitySchema.properties.AdStrength;
  const localized = {};
  _.each(adStrengthProperty.enum, (prop) => {
    localized[prop] = i18n.getString(`Ad_Strength_Score_${adStrengthProperty.enumValueMap[prop]}`);
  });
  _.extendOwn(adStrengthProperty, {
    filterable: true,
    chooseType: 'checkbox',
    title: i18n.getString('FilterLocalization_DataAttribute_AdStrength'),
    localized,
  });
  return adStrengthProperty;
}
